import { Location, LocationMapper } from '@nx-smartmonkey/shared/domain';

import { FieldMapping } from '../../../../../components/data-importer/fields/FieldMapping';
import { ClientDTO } from '../../../../../domain/client/ClientDTO';

export class CreateClientsList {
  constructor(private clientsData: ClientDTO[], private clientsAddresses: string[], private isUpdated?: boolean[]) {}

  getClientByIndex(index: number) {
    return this.clientsData[index];
  }

  getClientLabel(clientId: string) {
    const client = this.clientsData.find((client) => client.id === clientId);
    return client?.label;
  }

  getClientsAddresses() {
    return this.clientsAddresses;
  }

  getClientAddress(clientId: string) {
    const index = this.clientsData.findIndex((client) => client.id === clientId);
    return this.clientsAddresses[index];
  }

  getClientLocation(clientId: string) {
    const client = this.clientsData.find((client) => client.id === clientId);
    return client?.location ? LocationMapper.toDomain(client.location) : null;
  }

  getIsUpdatedById(clientId: string) {
    const index = this.clientsData.findIndex((client) => client.id === clientId);
    return this.isUpdated && this.isUpdated[index];
  }

  setClientLocation(clientId: string, location?: Location | null) {
    const client = this.clientsData.find((client) => client.id === clientId);
    const index = this.clientsData.findIndex((client) => client.id === clientId);
    if (client && location) {
      client.location = LocationMapper.toDTO(location);
      this.isUpdated![index] = true;
    }
    return new CreateClientsList(this.clientsData, this.clientsAddresses);
  }

  setClientAddresses(locations: (Location | null)[]) {
    if (locations.length !== this.clientsAddresses.length) {
      throw new Error(`The number of addresses does not match the number of clients`);
    }

    this.clientsData.forEach((client, index) => {
      client.location = locations[index] ?? undefined;
      this.isUpdated![index] = false;
    });

    return new CreateClientsList(this.clientsData, this.clientsAddresses);
  }

  getClients(): ClientDTO[] {
    return this.clientsData;
  }

  static create(clientsMapping: FieldMapping, isUpdated?: boolean[]) {
    const clients = clientsMapping.getData().map(({ id, ...client }) => ({ id: `${id}`, ...client })) as ClientDTO[];
    const clientsAddresses = clientsMapping.getAddresses();

    const isUpdatedList = isUpdated ?? clients.map(() => false);

    return new CreateClientsList(clients, clientsAddresses, isUpdatedList);
  }
}
